import React, { Component } from 'react';
import { dealValueShow, thousandBitSeparator } from '@/shared/functions';
import styled from 'styled-components';
const Root = styled.div `
  padding: 31px 31px 28px 31px;
  min-width: 437px;
  width: fit-content;
  background-color: #f7f7f7;
  border-radius: 8px;
  &.available .cardIcon {
    margin: 10px 36px 0 0;
    width: 33px;
    height: 31px;
  }
  .cardPart {
    flex: 1;
    .cardPart--content {
      margin-bottom: 10px;
      font-size: 30px;
      color: rgba(255, 87, 26, 0.9);
    }
    .cardPart--title {
      font-size: 20px;
      color: rgba(26, 26, 26, 0.9);
    }
  }
`;
class Card extends Component {
    render() {
        const { iconUrl, title, money, classNames, style } = this.props;
        return (<Root className={`flex__row-startS ${classNames}`} style={style}>
        <img className="cardIcon" src={iconUrl}/>
        <div className="cardPart">
          <div className="cardPart--content">
            {dealValueShow(thousandBitSeparator(money))}
          </div>
          <div className="cardPart--title">{title}</div>
        </div>
      </Root>);
    }
}
class AvailableMarginCard extends Component {
    render() {
        const iconUrl = require('@/assets/GroupManage/money@3x.png');
        const { money } = this.props;
        return (<Card classNames="available" iconUrl={iconUrl} title="可用保证金总额（元）" money={money}/>);
    }
}
export default AvailableMarginCard;
